import languagesApi from '../../api/languages-api';
import { config } from '../../shared/app.config';

const state = {
  languages: [],
  currentLanguage: '',
  currentLanguagePublic: '',
};

const mutations = {
  recoverLanguages (state) {
    const languages = JSON.parse(localStorage.getItem('languages'));
    if (!languages) {
      this.dispatch('getLanguages');
    } else {
      state.languages = languages;
    }
  },
  recoverCurrentLanguage (state) {
    const currentLanguage = JSON.parse(localStorage.getItem('currentLanguage'));
    if (!currentLanguage) {
      state.currentLanguage = config.defaultLocale;
      this.commit('setCurrentLanguage', state.currentLanguage);
    } else {
      state.currentLanguage = currentLanguage;
    }
  },
  checkNavLanguage (state, next) {
    const la = navigator.language.split('-')[0];
    const path = location.pathname;
    path.indexOf(1);
    path.toLowerCase();

    if (path.split('/')[1] == 'rest') {
      let parts = path.split('/');
      if (config.locales.includes(la) && parts[2] != la) {
        parts[2] = la;
        parts = parts.join('/');
        window.location.href = parts;
      }
    }
    // eslint-disable-next-line no-unused-expressions
    next;
  },
  recoverCurrentLanguagePublic (state) {
    const currentLanguagePublic = JSON.parse(localStorage.getItem('currentLanguagePublic'));
    if (!currentLanguagePublic) {
      state.currentLanguagePublic = config.defaultLocale;
      this.commit('setCurrentLanguagePublic', state.currentLanguagePublic);
    } else {
      state.currentLanguagePublic = currentLanguagePublic;
    }
  },
  setCurrentLanguage (state, payload) {
    state.currentLanguage = payload;
    localStorage.setItem('currentLanguage', JSON.stringify(state.currentLanguage));
  },
  setCurrentLanguagePublic (state, payload) {
    state.currentLanguagePublic = payload;
    localStorage.setItem('currentLanguagePublic', JSON.stringify(state.currentLanguagePublic));
  },
};

const actions = {
  getLanguages ({ commit }) {
    languagesApi.languages().then(response => {
      localStorage.setItem('languages', JSON.stringify(response.data));
      commit('recoverLanguages');
    });
  },
};

const getters = {
  getLanguages: state => state.languages,
  getCurrentLanguage: state => {
    if (state.currentLanguage) return state.currentLanguage;
    else return config.defaultLocale;
  },
  getCurrentLanguagePublic: state => {
    if (state.currentLanguagePublic) return state.currentLanguagePublic;
    else return config.defaultLocale;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
